// Central content + curated luxury imagery for The Standard
export const CONTACT = {
  phone: "470-424-6239",
  phoneHref: "tel:+14704246239",
  email: "miguel@calibartalent.com",
  serviceArea: "Serving discerning homeowners across the country",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1757356657991-c3fd6e2e812e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwaG9tZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc4NTgxNDkyMXww&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwc3VubGlnaHR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85",
  standard: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtYXJibGUlMjBiYXRocm9vbSUyMGVsZWdhbnR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85",
  finalCta: "https://images.unsplash.com/photo-1698956702197-202d8f60616b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBiZWRyb29tJTIwcGVyZmVjdGx5JTIwbWFkZSUyMGJlZCUyMGVsZWdhbnR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85",
};

export const PILLARS = [
  {
    title: "Exceptional Care",
    body: "Every detail is approached with precision and intention — from the grain of the marble to the fold of the linens.",
  },
  {
    title: "Trusted Professionals",
    body: "Carefully vetted, insured, and respectful professionals who treat every home with extraordinary care.",
  },
  {
    title: "Concierge Experience",
    body: "From scheduling to follow-up, every interaction is designed to be effortless and quietly exceptional.",
  },
];

export const EXPERIENCES = [
  {
    title: "Executive Weekly Care",
    body: "Consistent white-glove maintenance that keeps your home effortlessly pristine.",
    image:
      "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwc3VubGlnaHR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "White Glove Deep Clean",
    body: "An elevated top-to-bottom reset designed for exceptional homes.",
    image:
      "https://images.unsplash.com/photo-1671197244266-73129c97c096?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxkZXNpZ25lciUyMG1hcmJsZSUyMGtpdGNoZW4lMjBsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODU4MTQ5MjF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Seasonal Estate Refresh",
    body: "Quarterly luxury care that restores every space to its finest form.",
    image:
      "https://images.unsplash.com/photo-1631510390389-c1e4fb20ff31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwc3VubGlnaHR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Move-In Perfection",
    body: "Prepare your next chapter with a flawlessly refreshed home.",
    image:
      "https://images.unsplash.com/photo-1616594092403-fb65629b0a46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWRyb29tJTIwcGVyZmVjdGx5JTIwbWFkZSUyMGJlZCUyMGVsZWdhbnR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Vacation Home Care",
    body: "Luxury maintenance while you're away — your retreat, always ready.",
    image:
      "https://images.unsplash.com/photo-1558661091-5cc1b64d0dc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwaG9tZSUyMGV4dGVyaW9yJTIwc3Vuc2V0fGVufDB8fHx8MTc4NTgxNDkyMXww&ixlib=rb-4.1.0&q=85",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Schedule Your Cleaning",
    body: "Complete our luxury planning experience — a few refined questions about your home.",
  },
  {
    n: "02",
    title: "Personal Consultation",
    body: "We'll call to confirm details and prepare your customized quote.",
  },
  {
    n: "03",
    title: "Enjoy Your Home",
    body: "Arrive to a beautifully maintained space without lifting a finger.",
  },
];

export const STANDARDS = [
  {
    n: "01",
    title: "The Home Respect Standard",
    body: "Your home is treated as the private sanctuary it is — with discretion, care, and reverence for every surface.",
  },
  {
    n: "02",
    title: "The White Glove Standard",
    body: "A level of thoroughness measured not in tasks completed, but in the quiet perfection you notice afterward.",
  },
  {
    n: "03",
    title: "The Reliability Promise",
    body: "Punctual, consistent, and dependable. The same trusted professionals, every visit.",
  },
  {
    n: "04",
    title: "The Satisfaction Commitment",
    body: "If any detail falls short of your expectations, we return promptly to make it right.",
  },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1518733057094-95b53143d2a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwc3RhaXJjYXNlJTIwbW9kZXJuJTIwbHV4dXJ5JTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc4NTgxNDkyMXww&ixlib=rb-4.1.0&q=85", label: "Staircases" },
  { src: "https://images.unsplash.com/photo-1572297259518-0974576b6738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwbHV4dXJ5JTIwZGluaW5nJTIwcm9vbSUyMGludGVyaW9yJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc4NTgxODE1M3ww&ixlib=rb-4.1.0&q=85", label: "Dining" },
  { src: "https://images.unsplash.com/photo-1560185128-e173042f79dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiZWRyb29tJTIwcGVyZmVjdGx5JTIwbWFkZSUyMGJlZCUyMGVsZWdhbnR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85", label: "Bedrooms" },
  { src: "https://images.unsplash.com/photo-1564540583246-934409427776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtYXJibGUlMjBiYXRocm9vbSUyMGVsZWdhbnR8ZW58MHx8fHwxNzg1ODE0OTIxfDA&ixlib=rb-4.1.0&q=85", label: "Bathrooms" },
  { src: "https://images.unsplash.com/photo-1704383014646-2123f9dc8137?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxzdW5saWdodCUyMGVsZWdhbnQlMjBoYWxsd2F5JTIwbW9kZXJuJTIwbHV4dXJ5JTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc4NTgxODE1M3ww&ixlib=rb-4.1.0&q=85", label: "Hallways" },
  { src: "https://images.unsplash.com/photo-1683629357963-adf2b1fa9ad9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxkZXNpZ25lciUyMG1hcmJsZSUyMGtpdGNoZW4lMjBsdXh1cnklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODU4MTQ5MjF8MA&ixlib=rb-4.1.0&q=85", label: "Kitchens" },
];

export const REVIEWS = [
  {
    quote:
      "The Standard is the first service I've trusted completely inside our home. Every visit, the house feels renewed.",
    name: "Catherine R.",
    location: "Buckhead",
  },
  {
    quote:
      "It doesn't feel like a cleaning service. It feels like concierge care. Effortless from the first message.",
    name: "Jonathan M.",
    location: "Naples",
  },
  {
    quote:
      "The attention to detail is extraordinary. Our home has never looked, or felt, more considered.",
    name: "Priya & David S.",
    location: "Westlake",
  },
];

export const BOOKING = {
  frequency: ["Weekly", "Bi-Weekly", "Monthly", "One-Time", "Move-In / Move-Out"],
  homeSize: ["Under 2,000 sq ft", "2,000–3,500 sq ft", "3,500–5,000 sq ft", "5,000+ sq ft"],
  rooms: ["1", "2", "3", "4", "5", "6+"],
  focusAreas: [
    "Kitchen",
    "Primary Bathroom",
    "Windows",
    "Inside Oven",
    "Inside Refrigerator",
    "Laundry Room",
    "Pet Hair",
    "Other",
  ],
  pets: ["Yes", "No"],
};
